import { DeleteOccurrenceWorkScheduleSlotApiPayload } from '@omecare/utils';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { z } from 'zod';
import http from '@/utils/http.service';

const deleteOccurrenceWorkScheduleSlotResponseSchema = z.object({
  id: z.string().uuid(),
  exdate: z.array(z.string()),
});

export type DeleteOccurrenceWorkScheduleSlotResponse = z.infer<
  typeof deleteOccurrenceWorkScheduleSlotResponseSchema
>;
export type DeleteOccurrenceWorkScheduleSlotPayload = {
  id: string;
} & DeleteOccurrenceWorkScheduleSlotApiPayload;

const deleteOccurenceWorkScheduleSlot = (
  payload: DeleteOccurrenceWorkScheduleSlotPayload,
) => {
  return http.workScheduleSlots
    .deleteOccurrence(payload.id, {
      exdate: payload.exdate,
    })
    .then<DeleteOccurrenceWorkScheduleSlotResponse>(
      ({ response, transform }) => {
        return transform.handle({
          response,
          attributes: {
            exdate: true,
          },
          schema: deleteOccurrenceWorkScheduleSlotResponseSchema,
        });
      },
    );
};

const useDeleteOccurrenceWorkScheduleSlotMutation = (): UseMutationResult<
  DeleteOccurrenceWorkScheduleSlotResponse,
  Error,
  DeleteOccurrenceWorkScheduleSlotPayload
> => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: deleteOccurenceWorkScheduleSlot,
    onSuccess() {
      toast.success(t('http.delete-occurence-work-schedule-slot.success'));
    },
  });
};

export default useDeleteOccurrenceWorkScheduleSlotMutation;
